
export function objectPropertiesToCamelCase(obj: any): any {
  if (typeof obj !== 'object' || obj === null) return obj;

  if (Array.isArray(obj)) {
    return obj.map(item => objectPropertiesToCamelCase(item));
  }

  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [
      // Solo primera letra a minúscula, mantiene el resto
      key.charAt(0).toLowerCase() + key.slice(1),
      // Aplicar recursivamente a objetos/arrays
      objectPropertiesToCamelCase(value)
    ])
  );
}
